var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.12109 0.356791C2.6554 0.828336 2.66014 1.58812 3.13169 2.05382L3.29873 2.21891C3.40644 2.32542 3.56236 2.47967 3.75505 2.6705C4.14045 3.05221 4.67281 3.58014 5.26069 4.16506C6.43848 5.3369 7.83226 6.73074 8.71529 7.6373C9.4652 8.4072 10.4331 9.40392 11.2129 10.3366C11.6039 10.8042 11.9231 11.227 12.1383 11.5755L12.1469 11.5894C12.3031 11.8444 12.3044 12.1588 12.1503 12.4151C11.9475 12.7522 11.6487 13.1578 11.2895 13.5965C10.5746 14.4699 9.70712 15.3707 9.12637 15.9514L3.12637 21.9514C2.65775 22.4201 2.65775 23.1799 3.12637 23.6486C3.59501 24.1171 4.35485 24.1171 4.82348 23.6485L4.82416 23.6478L4.82507 23.6469L10.8235 17.6486C11.4246 17.0474 12.3571 16.0813 13.1467 15.1167C13.5398 14.6364 13.9194 14.1302 14.207 13.652C14.4592 13.2326 14.7749 12.8 14.7749 12C14.7749 11.2 14.4455 10.744 14.1804 10.3146C13.8784 9.82544 13.4769 9.30272 13.0541 8.79704C12.2063 7.7831 11.1742 6.72209 10.4345 5.9627C9.53668 5.04095 8.13046 3.63479 6.95346 2.46372C6.36395 1.87718 5.83023 1.34791 5.44389 0.96528C5.25071 0.773955 5.09434 0.619258 4.98624 0.512359L4.81811 0.346186C4.34657 -0.119506 3.58678 -0.114758 3.12109 0.356791Z",
    fill: "#3E3E3E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/SVG.a6745f483d686eddaefaee0878eba915.svg";
export { ForwardRef as ReactComponent };